/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Medialibraryprevious2Inputs */

const en_medialibraryprevious2 = /** @type {(inputs: Medialibraryprevious2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Previous asset`)
};

const de_medialibraryprevious2 = /** @type {(inputs: Medialibraryprevious2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorheriger Inhalt`)
};

/**
* | output |
* | --- |
* | "Previous asset" |
*
* @param {Medialibraryprevious2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const medialibraryprevious2 = /** @type {((inputs?: Medialibraryprevious2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Medialibraryprevious2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_medialibraryprevious2(inputs)
	return de_medialibraryprevious2(inputs)
});
export { medialibraryprevious2 as "mediaLibraryPrevious" }